import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { SwitchingAccountDisplay } from './models/switching-account.models';

@Component({
  selector: 'idp-switching-account',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './switching-account.component.html',
  styleUrls: ['./switching-account.component.scss']
})
export class SwitchingAccountComponent implements OnInit, AfterViewInit {
  @Input() content: SwitchingAccountDisplay = {} as SwitchingAccountDisplay;

  ngOnInit(): void {
    if (document.body) {
      document.body.style.overflow = 'hidden';
    }
    const modals = document.querySelectorAll('.profile-selector-machcore');
    modals?.forEach((modal) => {
      if (modal) {
        (modal as HTMLElement).style.display = 'none';
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
}
